import { render } from "./ImportOldOppOverviewNote.vue?vue&type=template&id=4fe18061&scoped=true"
import script from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js"
export * from "./ImportOldOppOverviewNote.vue?vue&type=script&lang=js"

import "./ImportOldOppOverviewNote.vue?vue&type=style&index=0&id=4fe18061&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe18061"]])

export default __exports__